<script setup>
import { create_faq, get_faq } from '@/services/faqs';
import { get_terms } from '@/services/terms';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()
const faq = ref({
  title: '',
  description: '',
  category: ''
})
const categoryOption = ref([])

onMounted(async ()=>{
  await retrieve_faq()
  await get_category()
})

async function retrieve_faq(){
  let response = await get_faq(route.params.id)
  console.log("🚀 ~ retrieve_faq ~ response:", response)
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  faq.value = {
    faq_obj: {...response.result.data.data},
    title: response.result.data.data.attributes.title,
    description: response.result.data.data.attributes.description,   
  }
}

async function get_category(){
  let response = await get_terms('faq_category')
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return 
  }
  categoryOption.value = parseOptions(response.result.data.data)
}

function parseOptions(cats){
  cats = cats.map(item => {
    return {
      valueProp: item.relationships.term_taxonomy.data.id,
      label: item.attributes.name,
      disabled: false  
    }
  })
  return cats
}

async function submit_form(){
  let params = {
    faq_obj:{
      title: faq.value.title,
      description: faq.value.description,
    },
    term_relationship:{
      term_taxonomy_id: faq.value.category
    }
  }
  let response = await create_faq(params)
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  Swal.fire({
    title: 'Added',
    text: 'Faq has been created',
    icon: 'success'
  })
  faq.value = {
    category: ''
  }
}
</script>

<template>
  <Breadcrumbs main="New FAQ"/>
  
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <input type="text" 
              name="title" 
              id="title" 
              class="form-control" 
              v-model="faq.title"
              placeholder="FAQ Title"
            >
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <textarea class="form-control" name="description" id="description" cols="30" rows="10" 
              v-model="faq.description"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <multiselect 
              v-model="faq.category" 
              placeholder="Select category"
              :options="categoryOption"
              valueProp="valueProp"
              searchable="true"
            ></multiselect>
            <button class="mt-2 btn btn-light-primary float-end" @click="submit_form()">
              Create FAQ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>